/**
 * Tabs
 */
// Note: These values are used for translation keys
export const BoothTab = {
  ALL: 'all',
  BOOKMARKS: 'bookmarks',
  WORLD1: 'avatar_bases',
  WORLD2: 'avatar_services_and_assets',
  WORLD3: '2d_illustration_and_other',
} as const;

export type BoothTab = (typeof BoothTab)[keyof typeof BoothTab];

export const BoothTabIdIncrease: Record<BoothTab, number> = {
  [BoothTab.ALL]: -Infinity,
  [BoothTab.BOOKMARKS]: -Infinity,
  [BoothTab.WORLD1]: 100,
  [BoothTab.WORLD2]: 400,
  [BoothTab.WORLD3]: 700,
};

export const BoothTabTheme = {
  [BoothTab.ALL]: '#ddd',
  [BoothTab.BOOKMARKS]: '#ddd',
  [BoothTab.WORLD1]: '#F7BF12',
  [BoothTab.WORLD2]: '#12CCF7',
  [BoothTab.WORLD3]: '#43F712',
};

/**
 * Tab sections
 */
export const BoothTabSection = {
  ALL: 'all',
  // Note: These values are used for translation keys
  UPPER: 'upper',
  MIDDLE: 'middle',
  LOWER: 'lower',
} as const;
export type BoothTabSection = (typeof BoothTabSection)[keyof typeof BoothTabSection];

export const BoothTabSectionIdIncrease: Record<BoothTabSection, number> = {
  [BoothTabSection.ALL]: -Infinity,
  [BoothTabSection.LOWER]: 0,
  [BoothTabSection.MIDDLE]: 100,
  [BoothTabSection.UPPER]: 200,
};
